export default "__VITE_ASSET__fW7rOKo___"